import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import './plugins/bootstrap-vue'
import router from './router'
import store from './store/store'

import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import FeatherWrapper from 'vue-feather-icons-wrapper'

import Moment from 'moment-timezone'

import axios from 'axios'
import VueAxios from 'vue-axios'

import Functions from './helpers/functions'

import VueAuthenticate from 'vue-authenticate'

import qa_auth from './auth/auth_config.json'
import social from './auth/auth_config_social.json'
import konverza from './auth/auth_config_social_konverza.json'
import preprod_konverza from './auth/preprod_auth_config_social_konverza.json'
import dashboardNameHelper, { getDashboardType } from './helpers/dashboard-name-helper'

import { Auth0Plugin } from './auth'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

import Request from './helpers/request'

import RequestSam from './helpers/request-sam'

import RequestFacebook from './helpers/request-facebook'

import RequestDani from './helpers/request-dani'

import RequestReports from './helpers/request-reports'

import RequestCases from './helpers/request-cases'

import RequestKpis from './helpers/request-kpis'

import RequestNotifications from './helpers/request-notifications'

import RequestSearch from './helpers/request-search'

import RequestVoip from './helpers/request-voip';

// Global mixin for sidenav control
import SidenavController from './helpers/sidenav-controller'

// Loader controller computed method plugin
import LoaderController from './helpers/loader-controller'

import ClearObject from './helpers/clear-object'

import PaginationHelper from './helpers/pagination-helper'

import PaginationHelper2 from './helpers/pagination-helper-2'

import VueProgressBar from 'vue-progressbar'

import { Message } from 'element-ui'

import VueCookies from 'vue-cookies'
import RecentsManager from './helpers/recents-manager'
import UserManager from './helpers/user-manager'

import { extend, localize, ValidationObserver, ValidationProvider } from 'vee-validate'
import es from 'vee-validate/dist/locale/es.json'
import * as rules from 'vee-validate/dist/rules'

import FormValidation from './helpers/validator-method'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import LoadingScreen from './helpers/loading-screen-controller'

import EmptyMessage from './components/EmptyMessage.vue'

import SideModal from './components/SideModal.vue'

import VueScrollTo from 'vue-scrollto'

import jQuery from 'jquery'

import 'jquery-ui'

import '@/helpers/jquery.panzoom-ignoreChildrensEvents'

import VueChatScroll from './plugins/vue-chat-scroll/vue-chat-scroll'

import ToggleDisabledStatus from './helpers/toggle-disabled-status'

import { abilitiesPlugin } from '@casl/vue'
import { ability } from './helpers/abilities'

import abilitiesManager from './helpers/abilities-manager'

import Breakpoints from './helpers/breakpoints-helper'

import VueNumberInput from '@chenfengyuan/vue-number-input'

import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

import LanguageManager from './helpers/language-manager'

import BlockConnector from './components/BlockConnector.vue'

import Treeselect from '@riophae/vue-treeselect'
import VueCountryCode from 'vue-country-code'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import '@/helpers/chartBorderRadius'

import 'tributejs/dist/tribute.css'
import VueTribute from 'vue-tribute'

import tributeHelper from '@/helpers/tribute'

import 'emoji-mart-vue-fast/css/emoji-mart.css'
Vue.component('v-icon', Icon)
Vue.component('v-select', vSelect)
Vue.use(FeatherWrapper)
Moment.locale('es')
Vue.prototype.$moment = Moment
Vue.use(VueAxios, axios)
Vue.use(Functions)
Vue.use(VueAuthenticate, {
  baseUrl: process.env.VUE_APP_API,
  loginUrl: '/login',
  storageNamespace: 'botlers',
  tokenPrefix: 'konverza',
  tokenPath: 'token',
  providers: {
    facebook: {
      clientId: process.env.VUE_APP_FACEBOOK_APP_ID,
      redirectUri: `${window.location.origin}/callback`,
      //scope: ['pages_messaging', 'pages_messaging_subscriptions', 'pages_show_list', 'pages_read_engagement', 'instagram_basic', 'instagram_manage_messages', 'pages_manage_metadata']
      scope: ['pages_messaging', 'pages_show_list', 'pages_read_engagement', 'pages_manage_metadata']
    },
    twitter: {
      redirectUri: `${window.location.origin}/callback`
    },
    shopify: {
      name: 'shopify',
      url: '/shopify/install',
      authorizationEndpoint: '',
      defaultUrlParams: ['client_id', 'scope', 'redirect_uri', 'state'],
      clientId: '0e783d66dd80156ee9a026d804571b0f',
      redirectUri: `${window.location.origin}/callback`,
      state: 'konverza_' + ((new Date()).getTime()),
      oauthType: '2.0',
      scope: ['read_products', 'write_products', 'read_draft_orders', 'write_draft_orders', 'read_orders', 'write_orders', 'read_shipping', 'write_shipping'],
      scopeDelimiter: ',',
      responseParams: {
        code: 'code',
        clientId: 'clientId',
        redirectUri: 'redirectUri',
        hmac: 'hmac',
        timestamp: 'timestamp',
        state: 'state',
        shop: 'shop'
      }
    },
    google: {
      clientId: process.env.VUE_APP_H4MAIL_CLIENT_ID,
      redirectUri: `${window.location.origin}/callback`,
      requiredUrlParams: ['scope', 'access_type', 'prompt'],
      scope: ['profile', 'email', 'https://mail.google.com/'],
      accessType: 'offline',
      prompt: 'consent'
    }
  }
})

const { domain, clientId, audience } = process.env.VUE_APP_ENV_MODE === 'qa'
  ? qa_auth
  : (getDashboardType() === 'socialkit' ? social : getKonverzaConfigFile())
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    console.log('appState', JSON.stringify(appState))
    router.push(
      {
        path: appState && appState.targetUrl
          ? appState.targetUrl
          : window.location.pathname,
        query: appState && appState.queryParams ? appState.queryParams : {}
      }
    )
  }
})

function getKonverzaConfigFile() {
  if (process.env.VUE_APP_ENV_MODE === 'preprod') {
    return preprod_konverza
  } else {
    return konverza
  }
}
Bugsnag.start({
  apiKey: 'fb2bd1efd4d1b8fe5e38e1322128f062',
  plugins: [new BugsnagPluginVue()],
  releaseStage: process.env.VUE_APP_ENV_MODE,
  appVersion: process.env.VUE_APP_VERSION,
  onError: function (event) {
    if (Vue.prototype.$getCookie('user') && Vue.prototype.$getCookie('user').admin_id) {
      event.setUser(Vue.prototype.$getCookie('user').admin_id, Vue.prototype.$getCookie('user').email, Vue.prototype.$getCookie('user').first_name)
    }
  }
})
const bugsnagVue = Bugsnag.getPlugin('vue')
bugsnagVue.installVueErrorHandler(Vue)
Vue.use(Request)
Vue.use(RequestSam)
Vue.use(RequestFacebook)
Vue.use(RequestDani)
Vue.use(RequestReports)
Vue.use(RequestCases)
Vue.use(RequestKpis)
Vue.use(RequestNotifications)
Vue.use(RequestSearch)
Vue.use(RequestVoip)
Vue.use(SidenavController)
Vue.use(LoaderController)
Vue.use(ClearObject)
Vue.use(PaginationHelper)
Vue.use(PaginationHelper2)
Vue.use(VueProgressBar, {
  color: '#4053ff',
  failedColor: 'rgb(245, 108, 108)',
  thickness: '2px',
  autoFinish: false,
  transition: {
    speed: '.8s',
    opacity: '.2s',
    termination: 800
  }
})
Vue.prototype.$message = Message
Vue.use(VueCookies)
Vue.prototype.$setCookie = (key, value, expire = '24h') => Vue.prototype.$cookies.set(key, value, expire, null, null, process.env.NODE_ENV === 'production', 'Strict')
Vue.prototype.$getCookie = key => Vue.prototype.$cookies.get(key)
Vue.use(RecentsManager)
Vue.use(UserManager)
localize('es', es)

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})
Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)
Vue.use(FormValidation)
Vue.use(Loading, {
  color: '#0e5ccf',
  zIndex: 2000,
  height: 70,
  width: 70,
  opacity: 0.6
})
Vue.use(LoadingScreen)
Vue.component(EmptyMessage.name, EmptyMessage)
Vue.component(SideModal.name, SideModal)
Vue.use(VueScrollTo)

Vue.config.productionTip = false
window.$ = window.jQuery = jQuery

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

Array.prototype.diff = function(a) {
  return this.filter(function(i) { return a.indexOf(i) < 0 })
}
Vue.use(VueChatScroll)
Vue.use(ToggleDisabledStatus)
Vue.use(abilitiesPlugin, ability)
Vue.use(abilitiesManager)
Vue.use(Breakpoints)
Vue.use(VueNumberInput)
Vue.use(VueCountryCode)
Vue.component('vue-timepicker', VueTimepicker)
Vue.component('date-range-picker', DateRangePicker)
Vue.use(dashboardNameHelper)
Vue.use(LanguageManager)
Vue.component('block-connector', BlockConnector)
Vue.component('treeselect', Treeselect)
Vue.component('vue-tribute', VueTribute)
Vue.mixin(tributeHelper)

/*
import {datadogRum} from '@datadog/browser-rum'
if  (process.env.NODE_ENV === 'production') {
  datadogRum.init({
    applicationId: '89bee9cc-1281-4042-8333-5361b9c1e685',
    clientToken: 'pub5cb5a2bcacd1a7dcce157c50aa3cc38a',
    site: 'datadoghq.com',
    service: getDashboardType(),
    version: version,
    env: process.env.NODE_ENV || 'development',
    sampleRate: 100,
    trackInteractions: true,
  })
}
*/

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
